import { css } from '@linaria/core';
import { styled } from '@linaria/react';

export const OutrightMarketsWrapper = styled.div`
  width: 100%;
`;

export const OutrightMarketsTitle = styled.h2`
  font-family: var(--oc-font-family);
  line-height: 27px;
  font-weight: 800;
  font-size: 20px;
  padding-bottom: 20px;
`;

export const TabNavContainer = styled.div``;

export const tabNavStyle = css`
  padding: 0 !important;
  width: 100% !important;

  /* Keyed off the stable attribute @cx-modules/ui's TabNav renders, not its generated class name —
     matching the class prefix only worked while the build passed Linaria \`displayName\` (NGF-6728). */
  div[data-cx-toolbar-item] {
    padding-right: 0 !important;
  }
`;

export const MarketListWrapper = styled.div`
  & > div:not(:first-child) {
    margin-top: 0;

    @media (min-width: 768px) {
      margin-top: 25px;
    }

    &.newUI {
      border-top: 1px solid var(--ogm-border-color-2);
    }
  }

  &.newUI {
    & > div {
      margin-top: 0;
    }

    border: 1px solid var(--ogm-border-color-1);
    border-radius: 5px;

    & > div * {
      font-family: var(--ogm-font-family-2);
    }
  }
`;

export const MarketTableWrapper = styled.div``;

export const OddsTableHeadersContainer = styled.div`
  display: grid;
  grid-template-columns: 0.6fr 0.4fr;
  padding: 15px 0;

  &.newUI {
    position: relative;
    --arrow-right-position: 20px;

    display: block;
    grid-template-columns: unset;
    padding: 12px 15px;

    & a {
      font-size: 16px;
      font-weight: 600;
      line-height: 20px;
    }
  }
`;

export const MarketTitleLinkContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const MarketTitleLink = styled.a`
  max-width: 90%;
  font-family: var(--oc-font-family);
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  text-decoration: none;
  color: var(--ogm-text-body);
  user-select: none;

  &.disabled {
    cursor: none;
    pointer-events: none;
    opacity: 0.5;
  }

  &:hover {
    text-decoration: underline;
  }
`;

export const CompareOddsLinkContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;

  &.newUI {
    padding: 10px 20px;
  }
`;

export const CompareOddsLink = styled.a`
  color: var(--oc-secondary-green);
  font-family: var(--oc-font-family);
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  text-decoration: none;
  padding: 0;
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  user-select: none;

  &:hover {
    text-decoration: underline;
  }

  &.newUI {
    color: var(--ogm-timberwolves);
    font-size: 14px;
    line-height: 21px;

    & > span {
      font-size: 14px;
      line-height: 21px;
    }
  }
`;

export const OddsTableWrapper = styled.div`
  border: 1px solid var(--oc-border);
  border-radius: 5px;

  &.newUI {
    border: none;
  }
`;

export const AllOutrightsLinkWrapper = styled.div`
  display: flex;
`;

export const AllOutrightsLink = styled.a`
  color: var(--oc-secondary-green);
  font-family: var(--oc-font-family);
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  text-decoration: none;
  margin-top: 20px;
  padding: 0 14px 0 0;
  position: relative;
  cursor: pointer;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  &:hover {
    text-decoration: underline;
  }

  &:after {
    display: inline-block;
    position: absolute;
    content: '';
    border: solid var(--oc-secondary-green);
    border-width: 0 1.5px 1.5px 0;
    padding: 2px;
    position: absolute;
    top: 50%;
    right: 0;
    transform: translate(-50%, -50%) rotate(-45deg);
  }
`;

export const outer = css`
  height: 100%;
  display: flex;
  align-items: center;

  /* As above (NGF-6728) — stable attribute rather than the generated Linaria class-name prefix. */
  [data-cx-tab-scroll-container] {
    margin: 0;
  }
`;

export const rightBtnClass = css`
  right: 0;
  display: none;

  @media (min-width: 1024px) {
    display: block;
    &:hover {
      button {
        border: 2px solid var(--oc-border);
      }
    }
  }
`;

export const leftBtnClass = css`
  left: 0;
  display: none;

  @media (min-width: 1024px) {
    display: block;
    &:hover {
      button {
        border: 2px solid var(--oc-border);
      }
    }
  }
`;

export const innerWrapperClass = css`
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const arrow = css`
  cursor: pointer;

  &:after {
    content: '';
    border: solid black;
    border-width: 0 2px 2px 0;
    display: inline-block;
    padding: 3px;
    transform: rotate(-135deg);
    transition:
      transform 0.25s ease-in-out,
      top 0.25s ease-in-out;
    position: absolute;
    right: var(--arrow-right-position);
    top: calc(50% - 5px);
  }

  &[aria-expanded='false']:after {
    transform: rotate(45deg);
  }
  &[aria-expanded='true']:after {
    transform: rotate(-135deg);
    top: calc(50% - 2px);
  }
`;

export const ArrowWrapper = styled.span`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 5px;
`;
